import { Link } from 'react-router-dom';
import { To } from 'history';
import { ButtonBase } from '@mui/material';
import { SxProps } from '@mui/system';
import Logo from './LogoMain';
import { APP_DEFAULT_PATH } from '../../config';
import { FC } from 'react';

interface Props {
	reverse?: boolean;
	sx?: SxProps;
	to?: To;
}

const LogoSection: FC<Props> = ({ reverse, sx, to }) => (
	<ButtonBase disableRipple component={Link} to={!to ? APP_DEFAULT_PATH : to} sx={sx}>
		<Logo reverse={reverse} />
	</ButtonBase>
);

export default LogoSection;
